export default __webpack_public_path__ + "static/logo-e75827398c69b5dc30293beb919105fe.png";